import React, { useState } from 'react';

/**
 * YouTubeFacade Component
 *
 * Shows a YouTube thumbnail with a play button overlay instead of loading
 * the full YouTube iframe on page load. The actual iframe only loads when
 * the user clicks the play button.
 *
 * This dramatically reduces third-party JS (~500KB per embed) and improves
 * Time to Interactive by 2-4 seconds on mobile.
 */
const YouTubeFacade = ({ videoId, title = 'Play video', height = 450, width = '100%' }) => {
  const [showIframe, setShowIframe] = useState(false);

  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

  if (showIframe) {
    return (
      <iframe
        src={embedUrl}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title}
        height={height}
        width={width}
        style={{ border: 0 }}
      />
    );
  }

  return (
    <button
      className="youtube-facade"
      onClick={() => setShowIframe(true)}
      aria-label={title}
      style={{
        position: 'relative',
        display: 'block',
        width: width,
        height: height,
        padding: 0,
        border: 'none',
        cursor: 'pointer',
        backgroundColor: '#000',
        overflow: 'hidden',
      }}
    >
      <img
        src={thumbnailUrl}
        alt={title}
        loading="lazy"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
      {/* YouTube-style play button */}
      <span
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '68px',
          height: '48px',
          backgroundColor: 'rgba(255, 0, 0, 0.8)',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'background-color 0.2s ease',
        }}
        className="youtube-facade-play-btn"
      >
        {/* Play triangle */}
        <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
          <path d="M8 5v14l11-7z" />
        </svg>
      </span>
    </button>
  );
};

export default YouTubeFacade;
